module.exports = __webpack_public_path__ + "img/cd.2ac94b0f.png";